/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UpdateUserRequest } from '../../models/update-user-request';
import { UpdateUserResult } from '../../models/update-user-result';

export interface ApiUsersMePatch$Params {
      body?: UpdateUserRequest
}

export function apiUsersMePatch(http: HttpClient, rootUrl: string, params?: ApiUsersMePatch$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateUserResult>> {
  const rb = new RequestBuilder(rootUrl, apiUsersMePatch.PATH, 'patch');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UpdateUserResult>;
    })
  );
}

apiUsersMePatch.PATH = '/api/Users/me';
